import ChooseTagModal from '@/components/ChooseTagModal'
import {
  addOrEditCustomer, getContactPhonesByld,
  getCustomerInfo,
  viewPhone,
  viewWeChat,
} from '@/services/customerManage'
import { getCustomerSource, getTagTreeByType } from '@/services/customerServices'
import { getEnums, httpOrgList } from '@/services/homeService'
import { getAuth } from '@/utils/auth'
import {PlusOutlined} from '@ant-design/icons'
import {Button,message} from 'antd'
import { useCallback, useEffect, useRef, useState } from 'react'
import { SDrawerOrModal, SGeneralForms, SMessage } from 'shj-components'
import dayjs from 'dayjs'
import { getParentId } from '@/utils/common'
import {isArray} from "lodash-es";
import {trimStrAll} from "@/utils/data.ts";

const NewOrEditCustomer = (props: {
  open: boolean
  onCancel: () => void
  openWay: 'add' | 'edit' | 'detailEdit'
  id: string
  listRef?: any
  setRefresh?: any
}) => {
  const { open, onCancel, openWay, id, listRef, setRefresh } = props
  const auth = getAuth()
  const formRef = useRef<any>()
  const [isErrorContactPhone, setIsErrorContactPhone] = useState(false)
  const [isErrorPhone, setIsErrorPhone] = useState(false)
  const [originPhone, setOriginPhone] = useState<string>('')
  const [originContactPhone, setOriginContactPhone] = useState<string>('')
  const [submitLoading, setSubmitLoading] = useState(false) // 提交时的加载状态
  const [tagList, setTagList] = useState<Array<any>>([]) // 标签列表
  const [companyList, setCompanyList] = useState<any[]>([]) // 适用门店列表
  const [selectTags, setSelectTags] = useState<Array<any>>([]) // 选择的标签
  const [openChooseTagModal, setOpenChooseTagModal] = useState(false) // 选择标签弹窗展示控制
  const [customerSourceList, setCustomerSourceList] = useState<Array<any>>([]) // 客户来源列表
  const [customerContactRelationList, setCustomerContactRelationList] = useState<Array<any>>([]) // 联系人关系列表

  const colorList = [
    {
      borderColor: 'rgba(250, 96, 80, 1)',
      fontColor: 'rgba(242, 90, 10, 1)',
    },
    {
      borderColor: 'rgba(0, 100, 255, 1)',
      fontColor: 'rgba(0, 100, 255, 1)',
    },
    {
      borderColor: 'rgba(245, 147, 0, 1)',
      fontColor: 'rgba(245, 147, 0, 1)',
    },
    {
      borderColor: 'rgba(112, 163, 16, 1)',
      fontColor: 'rgba(112, 163, 16, 1)',
    },
  ]

  // 获取客户标签
  const fetchTagTreeByType = async () => {
    try {
      const res: any = await getTagTreeByType('custom')
      const obj = {}
      if (res?.records) {
        const list: any = []
        // 一级分类
        res?.records?.forEach(item1 => {
          // 二级
          if (item1?.children && item1?.children?.length) {
            // 第二级为标签
            if (item1?.children?.[0]?.object.groupTag === 'tag' && !obj[item1?.id]) {
              obj[item1?.id] = true
              list.push({
                key: item1?.id,
                title: item1.label,
                // 二级分类下标签
                tags: item1?.children?.map(tag => ({
                  description: tag?.label,
                  key: tag?.id,
                  object: tag?.object,
                })),
              })
            }
            item1?.children.forEach(item2 => {
              // 三级分类
              if (item2?.children && item2?.children?.length) {
                // 第三级为标签
                if (item2?.children?.[0]?.object.groupTag === 'tag' && !obj[item2?.id]) {
                  obj[item2?.id] = true
                  list.push({
                    key: item2?.id,
                    title: item1.label + ' / ' + item2?.label,
                    // 二级分类下标签
                    tags: item2?.children?.map(tag => ({
                      description: tag?.label,
                      key: tag?.id,
                      object: tag?.object,
                    })),
                  })
                }
                item2?.children.forEach(item3 => {
                  if (item3?.children && item3?.children?.length) {
                    list.push({
                      key: item3?.id,
                      title: item1.label + ' / ' + item2?.label + ' / ' + item3?.label,
                      // 三级分类下标签
                      tags: item3?.children?.map(tag => ({
                        description: tag?.label,
                        key: tag?.id,
                        object: tag?.object,
                      })),
                    })
                  }
                })
              }
            })
          }
        })
        setTagList(list)
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 获取选择的标签
  const fetchDrawTags = (data: any) => {
    setSelectTags(data)
  }

  // 获取适用门店
  const getOrgList = async () => {
    const res: any = await httpOrgList()
    setCompanyList(res)
  }

  // 获取联系人关系
  const getCustomerContactRelationList = async () => {
    const res: any = await getEnums("cust-tenant", "com.shj.saas.cust.enums.CustomerContactRelationEnum")
    setCustomerContactRelationList(res)
  }

  // 获取客户详情
  const getCrmInfo = useCallback(
    async (list: any) => {
      const customerInfo: any = await getCustomerInfo({ id })
      let decryptedPhone: any = ''
      if (customerInfo?.phone && auth['contactViewPhone']) {
        setOriginPhone(customerInfo?.phone)
        decryptedPhone = await viewPhone(customerInfo?.id, 'customerViewPhone')
      }
      let decryptedWeChat: any = ''
      if (customerInfo?.wechatNo && auth['contactViewWeChat']) {
        decryptedWeChat = await viewWeChat(customerInfo?.id, 'customerViewWeChat')
      }
      let idPath = []
      if (list?.length > 0 && customerInfo?.channelId) {
        idPath = getParentId(list, customerInfo?.channelId)?.reverse()
      }
      // 处理联系人信息
      let decryptedContactPhone: any = '';let contactPersonObj:any = {};
      if(isArray(customerInfo?.contactPersonList)&&customerInfo?.contactPersonList?.length>0){
        const {name:contactName,phone:contactPhone,relation:contactRelation,id:contactId} = customerInfo.contactPersonList[0];
        // 联系人电话
        if (contactPhone&&auth['contactViewPhone']) {
          setOriginContactPhone(contactPhone)
          const data:any = await getContactPhonesByld(contactId);
          decryptedContactPhone = data?.phone||"";
        }
        contactPersonObj = {
          contactName:contactName || "",
          contactPhone:decryptedContactPhone || contactPhone || "",
          contactRelation:contactRelation || null,
        }
      }
      formRef.current?.onFormRef().setFieldsValue({
        ...customerInfo,
        ...contactPersonObj,
        channelId: idPath,
        phone: decryptedPhone ? decryptedPhone : customerInfo?.phone,
        wechatNo: decryptedWeChat ? decryptedWeChat : customerInfo?.wechatNo,
        birthday: customerInfo?.birthday ? dayjs(customerInfo?.birthday) : undefined,
      })
      const selectedTags = customerInfo?.tags?.map(item => {
        return {
          tagId: item?.tagId,
          key: item?.tagId,
          description: item?.tagName,
        }
      })
      setSelectTags(selectedTags)
      setSubmitLoading(false)
    },
    [id]
  )

  // 获取客户来源
  const getSource = useCallback(async () => {
    const res: any = await getCustomerSource({ state: openWay === 'add' ? 'CHECKED' : null })
    setCustomerSourceList(res)
    if (openWay === 'edit' || openWay === 'detailEdit') getCrmInfo(res)
  }, [getCrmInfo, openWay])

  // 判断是否可以编辑客户电话
  const canEditCustomerPhone = () => {
    const authMap = {
      edit: auth['editCustomerPhone'],
      detailEdit: auth['editCustomerPhoneInfo'],
      add: true,
    }

    return !!authMap[openWay]
  }

  // 判断是否可以编辑联系人手机号码
  const canEditContactPhone = () => {
    const authMap = {
      edit: auth['editContactPhone'],
      detailEdit: auth['editContactPhoneInfo'],
      add: true,
    }

    return !!authMap[openWay]
  }

  // 判断是否可以编辑客户微信
  const canEditCustomerWeChat = () => {
    const authMap = {
      edit: auth['editCustomerWeChat'],
      detailEdit: auth['editCustomerWeChatInfo'],
      add: true,
    }

    return !!authMap[openWay]
  }

  // 提交
  const onSubmit = async () => {
    // 校验必填项
    if (isErrorPhone) return message.error('号码格式不正确, 请填写完整的电话号码')
    if (isErrorContactPhone) return message.error('号码格式不正确, 请填写完整的联系人电话')

    const validateFields = await formRef.current
      ?.onFormRef()
      .validateFields()
      .catch(err => {
        console.log(err)
      })
    if (!validateFields) {
      return
    }

    // 整理选择的标签
    const tagList = selectTags
      ? selectTags.map(item => {
          return {
            id: item?.object?.id,
            code: item?.object?.code,
            name: item?.description,
            tagType: item?.object?.tagType,
            source: item?.object?.source,
            pid: item?.object?.pid,
            weight: item?.object?.weight,
          }
        })
      : undefined

    // 整理请求参数
    const params = formRef.current?.onFormRef().getFieldsValue();
    const {contactName,contactPhone,contactRelation,...otherFormData} = params;
    // 处理联系人信息
    let  contactPersonList:any[] = []
    contactPersonList = [
      {
        name:trimStrAll(contactName)||"",
        phone:contactPhone||"",
        relation:contactRelation||"",
      }
    ]
    const request = {
      tagList,
      ...otherFormData,
      birthday: params?.birthday ? dayjs(params?.birthday).toJSON() : undefined,
      channelId:
        params?.channelId?.length > 0
          ? params?.channelId[params?.channelId?.length - 1]
          : undefined,
      gender: params?.gender ? params.gender : '男',
      contactPersonList
    }

    try {
      setSubmitLoading(true)
      addOrEditCustomer(request)
        .then(() => {
          onCancel()
          message.success('操作成功')
          listRef && listRef.current?.reload()
          // 判断是否是详情页中打开编辑
          if (openWay === 'detailEdit') {
            setRefresh && setRefresh((prev: boolean) => !prev)
          }
        })
        .finally(() => {
          setSubmitLoading(false)
        })
    } catch (err) {
      setSubmitLoading(false)
      message.error(`操作失败: ${err}`)
    }
  }

  useEffect(() => {
    if (open) {
      openWay !== 'add' && setSubmitLoading(true)
      getOrgList()
      getCustomerContactRelationList()
      getSource()
      fetchTagTreeByType()
    } else {
      // 关闭时清空选项
      setSelectTags([])
      formRef.current?.onFormRef().resetFields()
    }
  }, [getSource, open, openWay])

  useEffect(() => {}, [customerSourceList])

  return (
    <>
      <SDrawerOrModal
        title={openWay === 'add' ? '新建客户' : '编辑客户'}
        mode="drawer"
        open={open}
        onCancel={onCancel}
        onOk={onSubmit}
        width={1010}
        antdProps={{
          destroyOnClose: true,
        }}
        loading={submitLoading}
      >
        <div style={{ margin: '0 10px' }}>
          <SGeneralForms
            ref={formRef}
            layout={'vertical'}
            configs={[
              {
                title: '客户信息',
                formItem: [
                  {
                    label: '客户编号',
                    name: 'id',
                    spanCol: 12,
                    comConfig: {
                      disabled: true,
                      placeholder: '无需填写，系统自动生成',
                    },
                  },
                  {
                    label: 'JDPIN',
                    name: 'pin',
                    spanCol: 12,
                    comConfig: {
                      disabled: true,
                      placeholder: '-',
                    },
                    hidden: openWay === 'add',
                  },
                  {
                    label: '客户名称',
                    name: 'name',
                    required: true,
                    spanCol: 12,
                    comConfig: {
                      maxLength: 50,
                      showCount: true,
                      placeholder: '请输入客户名称',
                      onBlur: e => {
                        const value = e.target.value
                        // 去除所有空格
                        if (value) {
                          const newValue = value.replace(/\s/g, '')
                          formRef.current?.onFormRef().setFieldValue('name', newValue)
                        }
                      },
                    },
                  },
                  {
                    label: '客户来源',
                    name: 'channelId',
                    required: true,
                    type: 'cascader',
                    spanCol: 12,
                    comConfig: {
                      options: customerSourceList,
                      expandTrigger: 'hover',
                      showSearch: true,
                      disabled: openWay === 'add' ? false : !auth['customerSourceEdit'],
                    },
                  },
                  {
                    label: '手机号码',
                    name: 'phone',
                    required: true,
                    spanCol: 12,
                    rules: [
                      { required: true, message: '请输入手机号码' },
                      {
                        pattern:
                          openWay === 'add'
                            ? /^1[3-9]\d{9}$/
                            : /^([1-9]{1}\d{2}(\d{4}|\*{4})\d{4})$/,
                        message: '请输入正确的手机号',
                      },
                    ],
                    comConfig: {
                      maxLength: 11,
                      placeholder: '请输入手机号码',
                      disabled: !canEditCustomerPhone(),
                      onBlur: e => {
                        if (openWay !== 'add') {
                          const newPhone = e.target.value
                          if (newPhone !== originPhone && /\*{4}/.test(newPhone)) {
                            setIsErrorPhone(true)
                            SMessage.confirm({
                              title: '号码格式不正确, 请填写完整的电话号码',
                              content: null,
                            })
                          } else {
                            setIsErrorPhone(false)
                          }
                        }
                      },
                    },
                  },
                  {
                    label: '微信号码',
                    name: 'wechatNo',
                    spanCol: 12,
                    comConfig: {
                      maxLength: 50,
                      disabled: !canEditCustomerWeChat(),
                    },
                  },
                  {
                    label: '客户生日',
                    name: 'birthday',
                    spanCol: 12,
                    type: 'date',
                  },
                  {
                    label: '客户年龄',
                    name: 'age',
                    spanCol: 12,
                    type: 'inputNumber',
                    comConfig: {
                      maxLength: 20,
                      min: 1,
                      precision: 0,
                      placeholder: '请输入客户年龄',
                    },
                  },
                  {
                    label: '客户性别',
                    name: 'gender',
                    spanCol: 12,
                    type: 'radio',
                    comConfig: {
                      defaultValue: '男',
                      options: [
                        { label: '男', value: '男' },
                        { label: '女', value: '女' },
                      ],
                    },
                  },
                ],
              },
              {
                title: '联系人信息',
                formItem: [
                  {
                    label: '联系人姓名',
                    name: 'contactName',
                    spanCol: 12,
                    comConfig: {
                      maxLength: 20,
                      placeholder: '请输入联系人姓名',
                    },
                  },
                  {
                    label: '联系人手机号码',
                    name: 'contactPhone',
                    spanCol: 12,
                    rules: [
                      {
                        pattern:
                          openWay === 'add'
                            ? /^1[3-9]\d{9}$/
                            : /^([1-9]{1}\d{2}(\d{4}|\*{4})\d{4})$/,
                        message: '请输入正确的联系人手机号码',
                      },
                    ],
                    comConfig: {
                      maxLength: 11,
                      placeholder: '请输入联系人手机号码',
                      disabled: !canEditContactPhone(),
                      onBlur: e => {
                        if (openWay !== 'add') {
                          const newPhone = e.target.value
                          if (newPhone !== originContactPhone && /\*{4}/.test(newPhone)) {
                            setIsErrorContactPhone(true)
                            SMessage.confirm({
                              title: '号码格式不正确, 请填写完整的电话号码',
                              content: null,
                            })
                          } else {
                            setIsErrorContactPhone(false)
                          }
                        }
                      },
                    },
                  },
                  {
                    label: '联系人关系',
                    name: 'contactRelation',
                    spanCol: 12,
                    type: 'select',
                    placeholder: '请输选择联系人关系',
                    comConfig: {
                      options: customerContactRelationList,
                      placeholder: '请输选择联系人关系',
                      fieldNames: { label: 'description', value: 'key' },
                    },
                  },
                ],
              },
              {
                title: '客户标签',
                formItem: [
                  {
                    spanCol: 24,
                    children: (
                      <>
                        <div style={{ width: '100%', display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                          {selectTags?.map((item, index) => {
                            return (
                              <span
                                key={item.key}
                                style={{
                                  display: 'inline-block',
                                  padding: '0 5px',
                                  marginBottom: 10,
                                  borderRadius: 3,
                                  border: `1px solid ${colorList[index % 4]?.borderColor}`,
                                  color: colorList[index % 4]?.fontColor,
                                }}
                              >
                                {item?.description}
                              </span>
                            )
                          })}
                        </div>
                        <Button icon={<PlusOutlined />} onClick={() => setOpenChooseTagModal(true)}>
                          选择标签
                        </Button>
                      </>
                    ),
                  },
                ],
              },
              {
                title: '负责人信息',
                formItem: [
                  {
                    label: '所属门店',
                    name: 'orgIds',
                    required: true,
                    spanCol: 12,
                    type: 'select',
                    comConfig: {
                      mode: 'multiple',
                      options: companyList,
                      fieldNames: { label: 'name', value: 'id' },
                    },
                  },
                ],
              },
            ]}
          />
        </div>
      </SDrawerOrModal>

      {/* 选择标签 */}
      {openChooseTagModal && (
        <ChooseTagModal
          getDataOnly={true}
          getSelectTags={fetchDrawTags}
          list={tagList as any}
          tagList={selectTags as any}
          open={openChooseTagModal}
          onClose={() => setOpenChooseTagModal(false)}
        />
      )}
    </>
  )
}
export default NewOrEditCustomer
